<template lang="pug">
  include ../../../../../pug/mixins/bem
  div
    +b.poll-title--centered.P {{ _('Скільки місяців вашому малюку?') }}
    +b.poll-child-decor
      +e.img.IMG(
        src='/static/images/poll-child.svg'
      )
    +b.range-wrap  
      range-slider(
        v-model="value", 
        :marks="marks"
        :height="15",
        :min='5'
        :max='13'
        tooltip='none'
      )
        template(#process='{ start, end, style, index }')
          .vue-slider-process.custom-process(
            :style="[style]"
          )
        template(#dot='')
          +b.custom-dot
        template(#mark='{ pos, value: current, label }')
          +b.custom-mark(
            :style='{"left": `${pos - 5}%`}'
            :class='{"is-active": value == current}'
          )
            +e.title.P {{ label }}
            +e.text.P {{ _('місяців') }}
    +b.poll-btn.BUTTON(
      href='',
      @click.prevent='next'
    ) {{ _('Далі') }}  
</template>
<script>
export default {
  name: 'AgeStep',
  data() {
    return {
      value: 5,
      marks: {
        5: {
          label: this._('до 6')
        },
        6: {
          label: this._('6')
        },
        7: {
          label: this._('7')
        },
        8: {
          label: this._('8')
        },
        9: {
          label: this._('9')
        },
        10: {
          label: this._('10')
        },
        11: {
          label: this._('11')
        },
        12: {
          label: this._('12')
        },
        13: {
          label: this._('12 +')
        },
       
      },
      data: [
        5,
        6, 
        7,
        8,
        9,
        10,
        11,
        12,
        13,
      ],
    }
  }, 
  methods: {
    next() {
      let obj = {
        age: this.marks[this.value].label,
        current: 'Products'
      }
      if (this.value == 5) {
        obj.current = 'Moz'
      }
      if (this.value == 13) {
        obj.current = 'Promo'
      }
      this.$emit('next', obj)
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/js/shared/components/poll/steps/age.vue